// Generated by Melange

import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_dictapis__Buhta_dict_v1alpha1_kbk_service from "../../../../proto/dictapis/gen/buhta_dict_v1alpha1_kbk_service.js";
import * as Curry from "melange.js/curry.js";

const Kbk = {};

const apiEndpointPrefix = "/dict";

function view(tenant, param) {
  const request = Curry._4(Buhta_dictapis__Buhta_dict_v1alpha1_kbk_service.Buhta.Dict.V1alpha1.GetKbkRequest.make, undefined, undefined, undefined, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.kbk;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_dictapis__Buhta_dict_v1alpha1_kbk_service.Buhta.Dict.V1alpha1.KbkService.getKbk, undefined, undefined, undefined, apiEndpointPrefix + Buhta_dictapis__Buhta_dict_v1alpha1_kbk_service.Buhta.Dict.V1alpha1.KbkService.GetKbk.name, undefined, undefined));
}

function grid(tenant, country, param) {
  const request = Curry._3(Buhta_dictapis__Buhta_dict_v1alpha1_kbk_service.Buhta.Dict.V1alpha1.ListKbksRequest.make, country, undefined, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.kbks;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_dictapis__Buhta_dict_v1alpha1_kbk_service.Buhta.Dict.V1alpha1.KbkService.listKbks, undefined, undefined, undefined, apiEndpointPrefix + Buhta_dictapis__Buhta_dict_v1alpha1_kbk_service.Buhta.Dict.V1alpha1.KbkService.ListKbks.name, undefined, undefined));
}

const KbkService = {
  view: view,
  grid: grid
};

export {
  Kbk,
  apiEndpointPrefix,
  KbkService,
}
/* Buhta_core__Grpc Not a pure module */
